import { useContext, useEffect, useState, useCallback } from "react";

import { UserContext } from "../../../context/User.context";

import {
  Button,
  Modal,
  Space,
  Table,
  Input,
  Select,
  Form,
  notification,
  DatePicker,
  Pagination,
} from "antd";
import { HomeFilled, InfoCircleFilled } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";

import { debounce } from "lodash"; // Menggunakan lodash untuk debounce
import { useHttp } from "../../../utils/DataHendler";
import axios from "axios";
import FileSaver from "file-saver";
import { useMediaQuery } from "react-responsive";

export const InstitutionTable = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 }); //
  const { getData, patchData } = useHttp();
  const { user } = useContext(UserContext);

  const { Search } = Input;

  const [loading, setLoading] = useState(false);
  const [deletedId, setDeletedId] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [dataDepartment, setDepartment] = useState([]);

  const [filters, setFilters] = useState({}); // State untuk menyimpan filter saat ini

  // LOADING STATE
  const [loadingDepartment, setLoadingDeparment] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [data, setData] = useState([]);

  useEffect(() => {
    // getVisitor();
    getDepartment();
    fetchData();
  }, [user]);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  // Fungsi untuk mengambil data dari API
  const fetchData = async (queryParams) => {
    setLoading(true);
    try {
      const response = await getData(
        `/institution`,
        { params: queryParams },
        true
      );

      if (response.success) {
        console.log(response);

        const structuredData = response.data.data.map(
          ({
            id,
            code,
            name,
            address,
            description,
            quota,
            department_id,
            department_name,
            created_at,
            updated_at,
          }) => ({
            key: id,
            id,
            code,
            name,
            address,
            description,
            quota,
            department_id,
            department_name,
            created_at,
            updated_at,
          })
        );
        setData(structuredData); // Data pengunjung
        setPagination({
          page: response.data.pagination.page,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handler untuk perubahan halaman
  const handlePageChange = (newPage) => {
    // fetchData( newPage, pagination.limit);
    handleFilterChange({ page: newPage || 1, limit: pagination.limit });
  };

  // Versi debounce dari getVisitor
  const debouncedGetVisitor = useCallback(
    debounce((newFilters) => {
      // getVisitor(newFilters); // Panggil getVisitor setelah debounce
      fetchData(newFilters);
    }, 900), // Delay 500ms
    []
  );
  // Handler untuk memperbarui filter dan panggil debouncedGetVisitor
  const handleFilterChange = (newFilter) => {
    const updatedFilters = { ...filters, ...newFilter };

    // Hapus filter yang di-set null atau kosong
    Object.keys(updatedFilters).forEach((key) => {
      if (updatedFilters[key] === null || updatedFilters[key] === "") {
        delete updatedFilters[key];
      }
    });

    setFilters(updatedFilters); // Perbarui state filters
    debouncedGetVisitor(updatedFilters); // Panggil versi debounce dari getVisitor
  };
  // // Fungsi handler untuk memperbarui filter dan memanggil API
  // const handleFilterChange = (newFilter) => {
  //   // Memperbarui state filters
  //   setFilters((prevFilters) => {
  //     const updatedFilters = { ...prevFilters, ...newFilter };

  //     // Hapus filter yang di-set null atau kosong
  //     Object.keys(updatedFilters).forEach((key) => {
  //       if (updatedFilters[key] === null || updatedFilters[key] === "") {
  //         delete updatedFilters[key];
  //       }
  //     });

  //     // Panggil API dengan filter yang diperbarui
  //     getVisitor(updatedFilters);

  //     return updatedFilters;
  //   });
  // };

  const getDepartment = async () => {
    setLoadingDeparment(true);

    try {
      const response = await getData("/department/lookup?limit=20", {}, false);
      setDepartment(response.data.data);
      setLoadingDeparment(false);
    } catch (error) {
      setLoadingDeparment(false);
    }
  };

  const handleOk = async (isApprove = true, idUnApprove) => {
    setConfirmLoading(true);

    try {
      const response = await patchData(
        `/visitor/approval/${isApprove ? deletedId : idUnApprove}`,
        {
          approve: isApprove ? true : false,
        },
        {},
        true
      );
      setDeletedId(0);
      setOpen(false);
      setConfirmLoading(false);
      // getVisitor();
      await fetchData();
      // message.success(res.data.message);
      isApprove
        ? api["success"]({
            message: "Approval Successfully Received",
            description: "Visitors get approval to enter the area",
          })
        : api["info"]({
            message: "Approval is cancelled",
            description: "Visitors are not allowed to enter the area",
          });
      // console.log(response.data);
    } catch (error) {
      setDeletedId(0);
      setOpen(false);
      console.log(error);
    }
  };
  const handleCancel = () => {
    // console.log("Clicked cancel button");
    setOpen(false);
  };

  const deleteVisitor = (deletedId) => {
    setLoading(true);

    patchData(
      `/visitor/delete`,
      {
        id: deletedId,
      },
      {},
      true
    )
      .then(async (res) => {
        // await getVisitor();
        await fetchData();
        api["success"]({
          message: "Data Deleted",
          description: "Visitor Data Has Been Delete",
        });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // Fungsi untuk mengunduh file Excel
  const downloadExcel = async () => {
    setLoading(true);
    try {
      // Kirim permintaan ke backend untuk mendapatkan file Excel
      const response = await axios.post(
        "https://cmi-general-platform-be.vercel.app/visitor/export", // Ganti dengan URL backend Anda
        {},
        {
          responseType: "blob", // Pastikan respons diolah sebagai blob
          params: filters,
        }
      );

      // Simpan file menggunakan FileSaver.js
      FileSaver.saveAs(new Blob([response.data]), "datavisitor.xlsx");

      // Tampilkan notifikasi sukses
      api["success"]({
        message: "File Excel berhasil diunduh",
        description: "File Excel berhasil diunduh",
      });
    } catch (error) {
      console.error("Error downloading Excel:", error);

      // Tampilkan notifikasi error
      api["error"]({
        message: "Gagal mengunduh file Excel.",
        description: "Silakan coba lagi atau hubungi administrator.",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => (
        <Space>
          {/* <Image width={90} src={product.coverImage} /> */}
          <p>{name}</p>
        </Space>
      ),
    },
    {
      title: "Quota",
      dataIndex: "quota",
      key: "quota",
    },

    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
    },

    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <>
          <Button
            icon={<InfoCircleFilled />}
            onClick={() => {
              navigate(`/user/institution/${record.id}`);
            }}
          />
        </>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
          justifyContent: isMobile ? "flex-start" : "space-between", // Sesuaikan alignment
          alignItems: isMobile ? "flex-start" : "center", // Sesuaikan alignment
          gap: isMobile ? "10px" : "0px", // Tambahkan jarak antar elemen jika mobile
        }}
      >
        {/* Bagian Filter */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
            gap: isMobile ? "10px" : "5px", // Tambahkan jarak antar elemen jika mobile
            width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
          }}
        >
          {/* Search Filter */}
          <Search
            style={{
              marginRight: isMobile ? "0px" : "5px", // Hapus margin kanan jika mobile
              width: isMobile ? "100%" : "200px", // Lebar penuh jika mobile
            }}
            placeholder="search name or code"
            allowClear
            onChange={(e) => {
              const value = e.target.value.trim();
              handleFilterChange({ search: value || null });
            }}
            onSearch={(value) => {
              handleFilterChange({ search: value.trim() || null });
            }}
            enterButton
          />

          {/* Date Range Filter */}
          {/* <RangePicker
            allowClear
            style={{
              marginRight: isMobile ? "0px" : "5px", // Hapus margin kanan jika mobile
              width: isMobile ? "100%" : "240px", // Lebar penuh jika mobile
            }}
            onCalendarChange={(dates, dateString) => {
              if (Array.isArray(dateString) && dateString.length === 2) {
                const [startDate, endDate] = dateString.map((d) => d.trim());
                const isValidDate = (dateString) =>
                  /^\d{4}-\d{2}-\d{2}$/.test(dateString);

                if (isValidDate(startDate) && isValidDate(endDate)) {
                  handleFilterChange({ "date[]": [startDate, endDate] });
                } else {
                  handleFilterChange({ "date[]": null });
                }
              } else {
                handleFilterChange({ "date[]": null });
              }
            }}
          /> */}

          {/* Department Filter */}
          <Select
            disabled={loadingDepartment}
            placeholder="Select Department"
            allowClear
            menuItemSelectedIcon={<HomeFilled />}
            onChange={(val) => {
              handleFilterChange({ department_id: val || null });
            }}
            options={dataDepartment.map((el) => ({
              value: `${el.id}`,
              label: el.name,
            }))}
            style={{
              width: isMobile ? "100%" : "200px", // Lebar penuh jika mobile
            }}
          />
        </div>

        {/* Tombol Export */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
            gap: isMobile ? "10px" : "5px", // Tambahkan jarak antar elemen jika mobile
            width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
          }}
        >
          {/* <Button
            style={{
              marginTop: isMobile ? "10px" : "0px", // Tambahkan margin atas jika mobile
              backgroundColor: "#41B3A2",
              color: "white",
              borderColor: "#41B3A2",
              width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
            }}
            icon={<DeliveredProcedureOutlined />}
            onClick={downloadExcel}
            loading={loading}
          >
            Export
          </Button> */}

          {/* <Button
            style={{
              marginTop: isMobile ? "0px" : "0px",
              marginLeft: isMobile ? "0px" : "10px",
              backgroundColor: "#088395",
              color: "white",
              borderColor: "#088395",
              width: isMobile ? "100%" : "auto",
            }}
            icon={<DeliveredProcedureOutlined />}
            onClick={() => {}}
            loading={loading}
          >
            Add Visitor
          </Button> */}
        </div>
      </div>
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        scroll={{
          x: "max-content", // Aktifkan scroll horizontal dengan lebar otomatis
          y: 550,
        }}
        // rowKey={(record) => record.id}
        pagination={false} // Matikan pagination bawaan Ant Design
        // expandable={{
        //   expandedRowRender: (record) => (
        //     <Space direction="vertical" size="middle">
        //       <Space size="middle">
        //         {
        //           <>
        //             <div style={{ display: "flex" }}>
        //               {/* <Barcode value={record.code} /> */}
        //               <div
        //                 style={{
        //                   display: "flex", // Menggunakan flexbox untuk mengatur layout
        //                   flexDirection: "column", // Menyusun elemen secara vertikal
        //                   alignItems: "center", // Menyusun elemen anak ke tengah secara horizontal
        //                   justifyContent: "center", // Menyusun elemen anak ke tengah secara vertikal
        //                   margin: "auto", // Memastikan div ini berada di tengah parent-nya
        //                   border: "2px solid rgb(0, 0, 0)", // Border dengan warna biru
        //                   borderRadius: "10px", // Radius border untuk tampilan lebih modern
        //                   padding: "5px", // Memberikan ruang di dalam border
        //                   width: "fit-content", // Lebar div menyesuaikan konten
        //                 }}
        //               >
        //                 <QRCode
        //                   id="myqrcode" // ID untuk referensi elemen QR Code
        //                   size={130} // Ukuran QR Code
        //                   errorLevel="H" // Tingkat kesalahan tinggi untuk QR Code
        //                   value={`${record?.code}`} // Nilai yang akan di-encode ke dalam QR Code
        //                   bgColor="#fff" // Warna latar belakang QR Code
        //                   type="canvas" // Pastikan tipe adalah "canvas"
        //                 />
        //                 <p
        //                   style={{
        //                     textAlign: "center", // Membuat teks berada di tengah
        //                     fontSize: "14px", // Ukuran font
        //                     fontWeight: "bold", // Membuat teks lebih tebal
        //                   }}
        //                 >
        //                   {record?.code}
        //                 </p>
        //               </div>

        //               <div style={{ display: "block" }}>
        //                 <Space
        //                   direction="vertical"
        //                   style={{ padding: "0 0 0 15px" }}
        //                 >
        //                   <div
        //                     style={{
        //                       fontWeight: "bold",
        //                       borderBottom: "2px solid #088395",
        //                       paddingBottom: "5px",
        //                       width: "fit-content",
        //                     }}
        //                   >
        //                     Approve At
        //                   </div>
        //                   <p
        //                     style={{
        //                       margin: 0,
        //                     }}
        //                   >
        //                     {record.expandableData.approve_at
        //                       ? formatTimeDate(record.expandableData.approve_at)
        //                       : "-"}
        //                   </p>
        //                   <div
        //                     style={{
        //                       fontWeight: "bold",
        //                       borderBottom: "2px solid #088395",
        //                       paddingBottom: "5px",
        //                       width: "fit-content",
        //                     }}
        //                   >
        //                     Approved By
        //                   </div>
        //                   <p
        //                     style={{
        //                       margin: 0,
        //                     }}
        //                   >
        //                     {record.expandableData.approver?.username ??
        //                       "belum diapprove"}
        //                   </p>
        //                 </Space>
        //                 {/* <Space
        //                   direction="vertical"
        //                   style={{ padding: "0 0 0 15px" }}
        //                 >
        //                   <div
        //                     style={{
        //                       fontWeight: "bold",
        //                       borderBottom: "2px solid #088395",
        //                       paddingBottom: "5px",
        //                       width: "fit-content",
        //                     }}
        //                   >
        //                     DiApprove Oleh
        //                   </div>
        //                   <p
        //                     style={{
        //                       margin: 0,
        //                     }}
        //                   >
        //                     {record.expandableData.approver?.username ??
        //                       "belum diapprove"}
        //                   </p>
        //                 </Space> */}
        //               </div>

        //               <Space
        //                 direction="vertical"
        //                 style={{ padding: "0 0 0 15px" }}
        //               >
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Expired At
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.expired_at == null
        //                     ? "please verified to start access"
        //                     : formatDate(record.expandableData.expired_at)}
        //                 </p>
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Verified By
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.verificator?.username ??
        //                     "belum diverifikasi"}
        //                 </p>
        //               </Space>
        //               <Space
        //                 direction="vertical"
        //                 style={{ padding: "0 0 0 15px" }}
        //               >
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Department
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.department_name}
        //                 </p>
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Appointment
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.appointment ?? "-"}
        //                 </p>
        //               </Space>
        //               <Space
        //                 direction="vertical"
        //                 style={{ padding: "0 0 0 15px" }}
        //               >
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   IN TIME
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   <Tag
        //                     // key={visitor.id}
        //                     color={"green"} // Warna sesuai status is_take
        //                     style={{
        //                       fontWeight: "bold",
        //                     }}
        //                   >
        //                     {record.expandableData.in_at
        //                       ? formatTimeDate(record.expandableData.in_at)
        //                       : "-"}
        //                   </Tag>
        //                 </p>
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   OUT TIME
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   <Tag
        //                     // key={visitor.id}
        //                     color={"red"} // Warna sesuai status is_take
        //                     style={{
        //                       fontWeight: "bold",
        //                     }}
        //                   >
        //                     {record.expandableData.out_at
        //                       ? formatTimeDate(record.expandableData.out_at)
        //                       : "-"}
        //                   </Tag>
        //                 </p>
        //               </Space>
        //             </div>
        //           </>
        //         }
        //       </Space>

        //       <Space direction="vertical" style={{ padding: "0 0 0 15px" }}>
        //         {/* TEMPAT KARTU */}
        //         {record.expandableData.card_visitors.length <= 0 ? (
        //           <span
        //             style={{
        //               color: "red",
        //               fontSize: "12px",
        //               // fontWeight: "normal",
        //               animation: "blink 1s infinite",
        //             }}
        //           >
        //             Don't Have a Visitor Card
        //           </span>
        //         ) : (
        //           <div>
        //             <div
        //               style={{
        //                 fontWeight: "bold",
        //                 borderBottom: "2px solid #088395",
        //                 paddingBottom: "5px",
        //                 width: "fit-content",
        //               }}
        //             >
        //               Card Used
        //             </div>

        //             <div
        //               style={{
        //                 display: "flex",
        //                 flexWrap: "wrap", // Memungkinkan elemen pindah ke baris baru jika tidak cukup ruang
        //                 gap: "10px", // Menambahkan jarak antara Tag
        //                 marginTop: "5px",
        //               }}
        //             >
        //               {record.expandableData.card_visitors.map((el) => (
        //                 <Tag
        //                   key={el.card_code} // Tambahkan key untuk setiap Tag agar lebih optimal
        //                   color={el.returned_at ? "red" : "green"} // Warna sesuai status is_take
        //                   style={{
        //                     fontWeight: "bold",
        //                     padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
        //                   }}
        //                 >
        //                   {`${el.card_code}`}
        //                   {el.returned_at != null ? ` | ` : ""}
        //                   <i>
        //                     {el.returned_at != null
        //                       ? ` ${formatTimeDate(el.returned_at)}`
        //                       : ""}
        //                   </i>
        //                 </Tag>
        //               ))}
        //             </div>
        //           </div>
        //         )}
        //       </Space>
        //     </Space>
        //   ),
        // }}
      />
      {/* Pagination Controls */}
      <Pagination
        current={pagination.page}
        pageSize={pagination.limit}
        total={pagination.total}
        onChange={handlePageChange}
        showSizeChanger={false}
        style={{ marginTop: 20, textAlign: "center" }}
      />
    </>
  );
};
